var map = {
	"./bg-bg.png": 1066,
	"./cs-cz.png": 1067,
	"./da-dk.png": 1068,
	"./de-at.png": 1069,
	"./de-ch.png": 1070,
	"./de-de.png": 1071,
	"./en-ae.png": 1072,
	"./en-bh.png": 1073,
	"./en-gb.png": 1074,
	"./en-ie.png": 1075,
	"./en-kw.png": 1076,
	"./en-lo.png": 1077,
	"./en-lv.png": 1078,
	"./en-om.png": 1079,
	"./en-qa.png": 1080,
	"./en-sa.png": 1081,
	"./en-xx.png": 1082,
	"./es-es.png": 1083,
	"./et-ee.png": 1084,
	"./events.png": 1085,
	"./fi-fi.png": 1086,
	"./fr-ch.png": 1087,
	"./fr-fr.png": 1088,
	"./hr-hr.png": 1089,
	"./hu-hu.png": 1090,
	"./it-ch.png": 1091,
	"./it-it.png": 1092,
	"./nl-be.png": 1093,
	"./nl-nl.png": 1094,
	"./no-no.png": 1095,
	"./pt-pt.png": 1096,
	"./ro-ro.png": 1097,
	"./sk-sk.png": 1098,
	"./sl-sl.png": 1099,
	"./sv-se.png": 1100
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1065;